import styled from 'styled-components';

export const FoodTypePickerOption = styled.button`
    align-items: center;
    background: transparent;
    border: 0;
    color: inherit;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    font-size: 18px;
    gap: 10px;
    margin: 0;
    opacity: 0.3;
    padding: 0;
    text-transform: uppercase;
    &:focus, &:hover {
        font-weight: bold;
        opacity: 1;
    }
`;